import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesCopyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-copy',
	path: '/secure/admin/CopyFieldLayoutScheme([!%]?[\\w]*).jspa',
};
